import { combineReducers } from 'redux';

import calendar from './calendar';
import dispatcher from './dispatcher';
import dropdowns from './dropdowns';
import events from './events';
import modals from './modals';
import organization from './organization';
import searchBids from './searchBids';
import searchJobs from './searchJobs';
import searchPurchaseOrders from './searchPurchaseOrders';
import settings from './settings';
import standardCrews from './standardCrews';
import tokenInfo from './tokenInfo';
import workOrders from './workOrders';
import searchEmployees from './searchEmployees';
import equipments from './equipments';
import searchAppointments from './searchAppointments';

export default combineReducers({
  calendar,
  dispatcher,
  dropdowns,
  events,
  modals,
  organization,
  searchBids,
  searchJobs,
  searchPurchaseOrders,
  settings,
  standardCrews,
  tokenInfo,
  workOrders,
  searchEmployees,
  equipments,
  searchAppointments
  
});
